import LabelValue from './LabelValue.vue'

export { LabelValue }
export default LabelValue
